<template>
  <div>
    <h2>{{mess}}</h2>
    <!-- //query接参 -->
    <!-- 消息编号：{{$route.query.id}}
    消息标题：{{$route.query.title}} -->

    <!-- 消息编号：{{$route.params.id}}
    消息标题：{{$route.params.title}} -->

        消息编号：{{id}}
    消息标题：{{title}}
  </div>
</template>

<script>

export default {
    name:'mession',
    props:['id','title'],
    data(){
        return{
 mess:'消息：今天不错'
        }
    },


    mounted(){
        console.log(this.$route)
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/study/study3/mession.vue